import PropTypes from 'prop-types'
import { Box, Container, Text, Heading } from '@redriverpress/system'

export default function CourseFocus({ words }) {
  return (
    <Box bg='gray200' py={[3, null, null, 4]}>
      <Container>
        <Heading p={0} mb={3} as='h2' fontSize={[3, null, 4]}>
          Focus
        </Heading>
        <Box display='flex' flexWrap='wrap'>
          {words.split(',').map(word => (
            <Box
              key={word}
              mr={2}
              mb={2}
              py={1}
              px={2}
              borderRadius='rounded'
              bg='white'
              width='fit-content'
            >
              <Text fontWeight='600' fontSize={0}>
                {word}
              </Text>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  )
}

CourseFocus.propTypes = {
  words: PropTypes.string.isRequired,
}
